<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Header
      :showGoBack="true"
      :title="'Payments'"
    />

    <main
      :class="'scrollable container'"
      :style="{paddingTop: '10px', paddingBottom: '20px'}"
    >
      <ul>
        <li
          :key="payment.id"
          class="clickable row-center"
          v-for="(payment, index) in payments"
          :style="{
            gap: '14px',
            marginBottom: index === payments.length - 1 ? '0' : '20px',
          }"
          @click="payment.route && $router.push(payment.route)"
        >
          <component :is="payment.icon" />
          <h5
            class="number-of-lines-1"
            :style="{marginRight: 'auto'}"
          >
            {{ payment.title }}
          </h5>
          <InfoSvg />
        </li>
      </ul>
    </main>
  </div>
</template>

<script setup>
import {useOpacity} from '@/hooks';

// components
import {Header} from '@/components';

// svg
import {CarSvg} from '@/assets/svg';
import {InfoSvg} from '@/assets/svg';
import {CharitySvg} from '@/assets/svg';
import {InvoiceSvg} from '@/assets/svg';
import {PayCheckSvg} from '@/assets/svg';
import {InsuranceSvg} from '@/assets/svg';
import {YellowCardSvg} from '@/assets/svg';
import {MobilePaymentSvg} from '@/assets/svg';
import {MoneyExchangeSvg} from '@/assets/svg';

import {routes} from '@/routes';

const opacity = useOpacity();

const payments = [
  {
    id: 1,
    title: 'Money transfer',
    icon: MoneyExchangeSvg,
    route: routes.FUND_TRANSFER,
  },
  {
    id: 2,
    title: 'Mobile payment',
    icon: MobilePaymentSvg,
    route: routes.MOBILE_PAYMENT,
  },
  {
    id: 3,
    title: 'IBAN payment',
    icon: PayCheckSvg,
    route: routes.IBAN_PAYMENT,
  },
  {
    id: 4,
    title: 'Utility bills',
    icon: InvoiceSvg,
    route: '',
  },
  {
    id: 5,
    title: 'Transport',
    icon: CarSvg,
    route: '',
  },
  {
    id: 6,
    title: 'Insurance',
    icon: InsuranceSvg,
    route: '',
  },
  {
    id: 7,
    title: 'Penalties',
    icon: YellowCardSvg,
    route: '',
  },
  {
    id: 8,
    title: 'Charity',
    icon: CharitySvg,
    route: '',
  },
];
</script>
